export enum RichTextEditorTheme {
  Snow = 'snow',
  Bubble = 'bubble'
}
